export enum ContractMasterGroupCodes {
    Forest = 'MONTE',
    Land = 'TIERRA',
    WoodServices = 'SMA',
};

export enum ContractMasterGroupNames {
    Forest = 'Monte',
    Land = 'Tierra',
    WoodServices = 'Servicios Madera',
};